import type {
  BlockStateDefinition,
  ImplicitDependencyGroup,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import type { ToggleBlockStateType, ToggleComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';
import type { Action } from '@unifyapps/defs/types/action';
import { getResolvedDefaultValue } from '../common/fields/BooleanField/utils/getResolvedDefaultValue';
import Toggle from './Toggle';
import { getNeoMorphicStyles } from './utils/getNeoMorphicStyles';

class ToggleBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'Toggle';
  }

  get initialStateGetter() {
    return (block: BlockType) => {
      const blockState = _pick(block.component as ToggleComponentType, [
        'content',
        'appearance',
        'componentType',
      ]);

      return {
        id: block.id,
        ...blockState,
        appearance: {
          ...blockState.appearance,
          neumorphicStyle: getNeoMorphicStyles(block) as Record<string, unknown>,
        },
      };
    };
  }

  getBlockControlMethods() {
    return [
      {
        id: 'setValue',
        label: 'Set Value',
        method: (blockState: ToggleBlockStateType, action: Action) => {
          const { methodPayload } = action.payload as {
            methodPayload: { value?: unknown };
          };
          return {
            ...blockState,
            value: getResolvedDefaultValue(methodPayload.value) ?? false,
          };
        },
      },
    ];
  }

  getImplicitDependencyGroups(): ImplicitDependencyGroup {
    return { usingDataSourcesResponse: true };
  }

  getComponent() {
    return Toggle;
  }
}

export default ToggleBlockStateDefinition;
